import React from 'react';

// import { media, palette } from '../../../styles';
import Button from '../Button';

const getWidth = (props) => {
  switch (props.size) {
    case 'large':
      return 48;
    case 'small':
      return 24;
    case 'default':
    default:
      return 32;
  }
};

const style = props => ({
  display: 'block',
  width: getWidth(props),
  minWidth: getWidth(props),

  paddingLeft: 0,
  paddingRight: 0,

  borderWidth: 0,
  boxShadow: 'none',

  '& svg': {
    display: 'block',
    margin: '0 auto',
  },

  ...props.style,
});

class IconButton extends React.PureComponent {
  render () {
    return (
      <Button
        {...this.props}
        style={style(this.props)}
      />
    );
  }
}

export default IconButton;




// WEBPACK FOOTER //
// ./src/components/ui/IconButton/IconButton.js